import { useEffect, useState } from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import { timelineOppositeContentClasses } from '@mui/lab/TimelineOppositeContent';
import {
  useChangeNewsVisibilityMutation,
  useCreateUpdateNewsMutation,
  useGetProjectNewsItemQuery,
  useGetProjectNewsQuery,
} from '../slices/historyApiSlice';
import {
  Alert,
  Box,
  Button,
  // Chip,
  CircularProgress,
  IconButton,
  Paper,
  Stack,
  styled,
  TextField,
  Typography,
} from '@mui/material';
import { getLocalDate } from '../utils/fn';
// import Fab from '@mui/material/Fab';

import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
// import UpIcon from '@mui/icons-material/KeyboardArrowUp';
// import { green } from '@mui/material/colors';
// import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
// import VisibilityIcon from '@mui/icons-material/Visibility';

import { Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import InfoRow from './Common/UI/InfoRow';
import { palette } from '../store/constant';

function trimMessage(message) {
  // Убираем "Сотрудник " в начале сообщения
  const trimmedMessage = message.replace(/^Сотрудник\s+/i, '');

  // Ищем индекс "у проекта"
  const index = trimmedMessage.indexOf('у проекта');
  let result = trimmedMessage;

  if (index !== -1) {
    result = trimmedMessage.substring(0, index).trim(); // Обрезаем строку до "у проекта"
  }

  // Проверяем, идет ли после слова "Сотрудник" слово "Динара"
  const words = message.split(' ');
  if (words[1] === 'Динара') {
    const actionWords = result.split(' ');
    if (actionWords.length >= 2) {
      // Изменяем глагол на женский род
      const verb = actionWords[1];
      if (verb.endsWith('л') || verb.endsWith('л')) {
        // Проверяем, если глагол в прошедшем времени
        actionWords[1] = verb.slice(0, -1) + 'ла'; // Пример: "завершил" -> "завершила"
      } else {
        actionWords[1] += 'а'; // Добавляем окончание "а" для других глаголов
      }
      result = actionWords.join(' ');
    }
  }

  return result; // Возвращаем итоговое сообщение
}
const Item = ({ leftTitle, item, last, update, editable, setShowNewsById }) => {
  // console.log('item', item);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = () => {
    // Логика удаления
    console.log('Удалить');
    update(item._id);
    handleClose();
  };

  const handleEdit = () => {
    // Логика редактирования
    console.log('Редактировать');
    setShowNewsById(item._id);
    handleClose();
  };

  let secondLine = '';
  // let thirdLine = '';
  //  if (item.event === 'CREATE_PROJECT') {
  //    secondLine = `Сотрудник ${item?.user?.name} создал новый клиент`;
  // } else if (item.event === 'CLOSE_PROJECT') {
  //   secondLine = 'Завершил объект';
  // } else if (item.event === 'START_STAGE') {
  //   secondLine = `Начал этап ${item.stage?.title}`;
  //   // thirdLine = `Начал этап ${item.stage?.title}`;
  // } else if (item.event === 'CLOSE_STAGE') {
  //   secondLine = `Завершил этап ${item.stage?.title}`;
  //   // thirdLine = `Завершил этап ${item.stage?.title}`;
  // } else {
  secondLine = trimMessage(item.message);
  // }

  return (
    <TimelineItem>
      <TimelineOppositeContent color='textSecondary' sx={{ pl: 0 }}>
        <Typography sx={{ fontSize: '12px' }} variant='body2'>
          {getLocalDate(leftTitle) || leftTitle}
        </Typography>
      </TimelineOppositeContent>
      <TimelineSeparator>
        <TimelineDot />
        {!last && <TimelineConnector />}
      </TimelineSeparator>
      <TimelineContent>
        {editable ? (
          <Stack
            direction='row'
            spacing={0}
            justifyContent='space-between'
            alignItems='center'
          >
            <Stack direction='column' spacing={0}>
              <Typography
                component='div'
                variant='body1'
                sx={{
                  textDecoration: item.hidden ? 'line-through' : 'none',
                  color: item.hidden ? '#999' : 'inherit',
                }}
              >
                {secondLine}
              </Typography>
              {item?.manual && (
                <>
                  <Typography component='div'>
                    {item?.user?.name}
                    {' ➜ '}
                    {item?.stage?.shortName
                      ? item?.stage?.shortName
                      : item?.stage?.title}
                  </Typography>
                </>
              )}
            </Stack>

            <IconButton
              aria-label='more options'
              aria-controls={open ? 'dropdown-menu' : undefined}
              aria-haspopup='true'
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
            >
              <MoreVertIcon />
            </IconButton>

            <Menu
              id='dropdown-menu'
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'more-button',
              }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              {item?.manual && (
                <MenuItem onClick={handleEdit}>
                  <ListItemIcon>
                    <EditIcon fontSize='small' />
                  </ListItemIcon>
                  <ListItemText>Редактировать</ListItemText>
                </MenuItem>
              )}

              <MenuItem onClick={handleDelete}>
                <ListItemIcon>
                  <DeleteIcon fontSize='small' />
                </ListItemIcon>
                <ListItemText>
                  {item.hidden ? 'Восстановить' : 'Скрыть'}
                </ListItemText>
              </MenuItem>
            </Menu>
          </Stack>
        ) : (
          <Stack direction='column' spacing={0}>
            <Typography component='div'>{secondLine}</Typography>
            {item?.manual && (
              <Typography component='div'>{item?.user?.name}</Typography>
            )}
          </Stack>
        )}
      </TimelineContent>
    </TimelineItem>
  );
};

const NewsForm = ({
  projectId,
  newsId,
  setNewsId,
  currentStage,
  theme,
  setAlertMessage,
}) => {
  const [message, setMessage] = useState('');

  const { data } = useGetProjectNewsItemQuery(
    {
      projectId,
      newsId,
    },
    {
      skip: !newsId,
    }
  );

  // console.log('currentStage', currentStage);

  const [createUpdateNews] = useCreateUpdateNewsMutation();

  const createUpdateNewsHandler = async () => {
    const newsData = {
      stageId: currentStage?._id,
      newsId: newsId,
      projectId: projectId,
      message: message,
    };

    // console.log('newsData', newsData);

    try {
      await createUpdateNews(newsData).unwrap();
      setMessage('');
      setNewsId('');
    } catch (error) {
      setAlertMessage(
        error?.data?.message || error?.error || error?.message || error
      );
    }
  };

  useEffect(() => {
    if (data?.item) {
      // console.log(data);
      setMessage(data?.item?.message);
    }
  }, [data]);

  return (
    <>
      <Stack
        direction='row'
        spacing={0}
        items={'flex-start'}
        justifyContent={`space-between`}
        sx={{ mt: 1 }}
      >
        <Typography component='div' variant='body1' sx={{ ml: 1, mt: 2 }}>
          {!!newsId
            ? newsId === 'new'
              ? 'Новое событие'
              : 'Редактировать событие'
            : 'Хронология событий:'}
        </Typography>
        <ButtonItem>
          <IconButton
            aria-label='add to favorites'
            href='#file-upload'
            component='label'
            onClick={() => setNewsId(!!newsId ? '' : 'new')}
          >
            {!!newsId ? <CloseIcon /> : <AddIcon />}
          </IconButton>
        </ButtonItem>
      </Stack>
      {!!newsId && (
        <Stack
          direction='column'
          spacing={1}
          items={'flex-start'}
          justifyContent={`space-between`}
          sx={{
            mt: 1,
            border: `1px solid ${palette[theme]['info']}`,
            p: 1,
          }}
        >
          <InfoRow title='Этап' value={currentStage?.title} />
          <TextField
            multiline
            minRows={3}
            maxRows={5}
            size='small'
            fullWidth
            value={message || ''}
            onChange={(e) => setMessage(e.target.value)}
          />
          <Button variant='contained' onClick={createUpdateNewsHandler}>
            {newsId === 'new' ? 'Создать новое' : 'Сохранить изменения'}
          </Button>
        </Stack>
      )}
    </>
  );
};

const ButtonItem = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(0),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const ProjectHistory = ({ projectId, stages, theme, setAlertMessage }) => {
  const { data, isLoading, isError, error } = useGetProjectNewsQuery(projectId);
  const [changeNewsVisibility] = useChangeNewsVisibilityMutation();
  // const [createUpdateNews] = useCreateUpdateNewsMutation();
  const [showNewsById, setShowNewsById] = useState(''); //идентификатор новости
  // const [newsMessage, setNewsMessage] = useState('');

  // console.log('data', data);
  const visibleStages = stages?.filter((stage) => stage.visible);
  //Как найти текущий этап:
  //1. Найти этап у которого свойство state === 'start'
  //2. Найти этап со свойство state === '', которому предшествует этам со свойство state === 'done'

  let currentStage;
  currentStage = visibleStages?.find((stage) => stage.state === 'start');
  if (!currentStage) {
    // Ищем этап с пустым state, который идет сразу после последнего done
    const stagesWithIndex = visibleStages?.map((stage, index) => ({
      ...stage,
      index,
    }));
    const lastDoneStage = stagesWithIndex
      ?.filter((stage) => stage.state === 'done')
      ?.sort((a, b) => b.order - a.order)[0];

    if (lastDoneStage) {
      // Ищем следующий видимый этап с пустым state
      const nextEmptyStage = stagesWithIndex?.find(
        (stage) =>
          stage.index > lastDoneStage.index &&
          stage.state === '' &&
          stage.visible
      );

      if (nextEmptyStage) {
        currentStage = nextEmptyStage;
      } else {
        currentStage = lastDoneStage;
      }
    } else {
      currentStage = visibleStages[0];
    }
  }

  const updateVisibility = async (id) => {
    // console.log('updateVisibility', id);

    try {
      await changeNewsVisibility(id).unwrap();
    } catch (error) {
      setAlertMessage(
        error?.data?.message || error?.error || error?.message || error
      );
    }
  };

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex' }}>
        <CircularProgress />
      </Box>
    );
  } else if (isError) {
    return (
      <Box sx={{ display: 'flex' }}>
        <Alert severity='warning'>{error?.data?.message || error.error}</Alert>
      </Box>
    );
  }

  return (
    <>
      <NewsForm
        projectId={projectId}
        newsId={showNewsById}
        setNewsId={setShowNewsById}
        currentStage={currentStage}
        theme={theme}
        setAlertMessage={setAlertMessage}
      />

      <Timeline
        sx={{
          [`& .${timelineOppositeContentClasses.root}`]: {
            flex: 0.2,
          },
        }}
      >
        {Array.isArray(data?.rows) &&
          data?.rows.map((row, index) => (
            <Item
              editable={data?.editable}
              update={updateVisibility}
              key={row._id}
              leftTitle={row.createdAt}
              item={row}
              last={index === data.rows.length - 1}
              setShowNewsById={setShowNewsById}
            />
          ))}
      </Timeline>
    </>
  );
};

export default ProjectHistory;
